// Keys shared with the web app on this origin; renaming either breaks sign-out across the two
// apps. The pending flag is left set after a sign-out here, for the web app to clear.

const STATUS_KEY = 'session_status';
const LOGOUT_PENDING_KEY = 'session_logout_pending';

export function beginWebLogout() {
  try {
    localStorage.setItem(LOGOUT_PENDING_KEY, 'true');
  } catch { /* quota exceeded or private browsing — the web app reconciles from Firebase */ }
}

export function clearWebSessionStatus() {
  try {
    localStorage.removeItem(STATUS_KEY);
  } catch { /* quota exceeded or private browsing — the web app reconciles from Firebase */ }
}

export function isWebLogoutPending() {
  try {
    return localStorage.getItem(LOGOUT_PENDING_KEY) != null;
  } catch {
    return false;
  }
}

export function onWebLogout(callback) {
  const onStorage = (event) => {
    if (event.key === LOGOUT_PENDING_KEY && event.newValue != null) callback();
  };
  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}
